<div class="ui breadcrumb">
  <ng-template ngFor let-item [ngForOf]="breadcrumb" let-index="index" let-last="last">
    <a data-e2e="breadcrumb-link" class="section" *ngIf="item.commands" [routerLink]="item.commands">{{item.title}}</a>
    <a data-e2e="breadcrumb-active" class="section" [class.active]="last" *ngIf="!item.commands">{{item.title}}</a>
    <span class="beta-tag" *ngIf="item.isBetaTag" i18n>BETA</span>
    <i class="icon small caret" *ngIf="!last && breadcrumb[index + 1].title"> <svg   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 11.98"><path fill="#ABABAB" d="M10 5.99l-10 6v-12z"/></svg> </i>
  </ng-template>
</div>
